<template>
  <v-app id="main">
    <v-main>
      <AppBar :to-drawer="drawer" @fromDrawer="onDrawer" />
      <Drawer :to-drawer="drawer" @fromDrawer="onDrawer" />
      <v-container fluid>
        <Snackbar />
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from "./AppBar.vue";
import Drawer from "./Drawer.vue";
import Snackbar from "@/components/errors/Snackbar.vue";

export default {
  name: "MainLayout",
  components: {
    AppBar,
    Drawer,
    Snackbar
  },
  data: () => ({
    drawer: true
  }),
  // created() {
  //   this.$vuetify.theme.dark = false;
  // },
  methods: {
    onDrawer(val) {
      this.drawer = val;
    }
  }
};
</script>
